export { default } from './PendingChangesAuthorsNotice';
